import type { SampleSource } from '@/models/models';
import type { CentrifugeRole } from '@/models/models';
import type { Language } from '@/i18n/LanguageContext';

const normalizeName = (name: string) =>
  name.trim().toLocaleLowerCase().replace(/\s+/g, ' ');

export const findSampleSource = (
  catalog: SampleSource[],
  name: string
): SampleSource | undefined => {
  const normalizedName = normalizeName(name);
  return catalog.find((source) =>
    [source.english_name, ...source.aliases].some(
      (candidate) => normalizeName(candidate) === normalizedName
    )
  );
};

export const sampleSourceDisplayName = (
  catalog: SampleSource[],
  name: string,
  language: Language
): string => {
  const source = findSampleSource(catalog, name);
  if (!source) return name;
  return language === 'es' ? source.spanish_name : source.english_name;
};

const CENTRIFUGE_ROLES = new Set<CentrifugeRole>([
  'ls_suction',
  'ls_effluent',
  'drying_effluent',
  'hs_effluent',
  'centrifuge_1_suction',
  'centrifuge_1_effluent',
  'centrifuge_2_suction',
  'centrifuge_2_effluent',
]);

export const centrifugeRole = (
  catalog: SampleSource[],
  name: string
): CentrifugeRole | null => {
  const key = findSampleSource(catalog, name)?.key as CentrifugeRole | undefined;
  return key && CENTRIFUGE_ROLES.has(key) ? key : null;
};

export const calibrationSlotDisplayName = (
  catalog: SampleSource[],
  slot: string,
  language: Language
): string => {
  const names = catalog
    .filter((source) => source.calibration_slot === slot)
    .map((source) =>
      language === 'es' ? source.spanish_name : source.english_name
    );
  return names.length > 0 ? names.join(' / ') : slot;
};
